import React from 'react';
import { Tabs, Tab, Nav, NavItem, Row, Col } from 'react-bootstrap';
import { MyContest } from '../Component/MyContest';
import { Utilities, _Map, _filter, _debounce } from '../Utilities/Utilities';
import { Helmet } from "react-helmet";
import queryString from 'query-string';
import ls from 'local-storage';
import Loadable from 'react-loadable';
import MetaData from "../helper/MetaData";
import WSManager from '../WSHelper/WSManager';
import Profile from '../Component/Profile/MyProfile';
import Lobby from './Lobby';
import CustomHeader from '../components/CustomHeader';
import More from './More';
import Notification from '../views/Notification';
import Wallet from '../Component/Finance/MyWallet';
import ReferFriend from './ReferFriend';
import Images from '../components/images';
import * as AppLabels from "../helper/AppLabels";
import * as Constants from "../helper/Constants";
import { Sports } from "../JsonFiles";
import hockeyIcon from "../assets/img/hockey.svg";


export const MyContext = React.createContext()
var mContext = null;
function LoadingComponent() {
    return <div className="web-container" />;
}
const PredictionLobby = Loadable({
    loader: () => {
        return import('../Component/PredictionModule/PredictionLobby')
    },
    delay: 0,
    loading: LoadingComponent
});
const MyPrediction = Loadable({
    loader: () => {
        return import('../Component/PredictionModule/MyPredictions')
    },
    delay: 0,
    loading: LoadingComponent
});

export default class Dashboard extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            activeSportsTab: 0,
            ShimmerList: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
            activeTab: 'lobby',
            urlParams: '',
            sportsList: [],
            showLobbyFitlers: false,
            EarnCoins: LoadingComponent,
            PredictionLobby: LoadingComponent,
            MyPrediction: LoadingComponent,
            selectedGameType: WSManager.getPickedGameType(),
            getGameTypeSport: Utilities.getGameTypeSports(),
            MultiGame: LoadingComponent,
            CurrentGameType: Constants.SELECTED_GAMET,
            headerReload: true,
            AvaSports: [],
            HeaderOption: {
                menu: true,
                title: "",
                notification: true,
                filter: true,
                edit: false,
                hideShadow: true,
                hideHeader: false,
                close: false
            },
            footerTabs: Constants.DASHBOARD_FOOTER.tabs

        }
        this.ref = React.createRef();

    }

    UNSAFE_componentWillMount() {
        if (!this.checkPickedGame()) {
            let sports_id = Utilities.getUrlSports();
            this.setState({ sportsList: Utilities.getMasterData().fantasy_list ? Utilities.getMasterData().fantasy_list : [] }, () => {
                Constants.setValue.setAppSelectedSport(sports_id);

                let url = this.props.location.search;
                let urlParams = queryString.parse(url);

                let pathData = Constants.DASHBOARD_FOOTER.config.tab_path;
                let event = pathData[window.location.pathname];

                this.onSelect(event, true);
                this.setState({ activeTab: event, urlParams, activeSportsTab: sports_id })
                if (Constants.AppSelectedSport == null) {
                    this.checkSportId();
                }
            })

            if (Utilities.getMasterData().a_coin == 0 || !WSManager.loggedIn()) {
                var filterArray = _filter(Constants.DASHBOARD_FOOTER.tabs, (item) => {
                    return item.tab_key !== 'earn-coins'
                })
                this.setState({ footerTabs: filterArray })
            }
            if (Utilities.getMasterData().a_coin == '1') {
                import('../Component/CoinsModule').then(CM => {
                    if (CM.EarnCoins) {
                        this.setState({
                            EarnCoins: CM.EarnCoins
                        });
                    }
                });
            }
            if (Constants.SELECTED_GAMET == Constants.GameType.MultiGame) {
                import('../Component/MultiGameModule').then(MM => {
                    if (MM.MultiGameLobby) {
                        this.setState({
                            MultiGame: MM.MultiGameLobby,
                        });
                    }
                });
            }
            WSManager.setShareContestJoin(false);
        }

        if (this.state.getGameTypeSport) {
            var gametypeArray = this.state.getGameTypeSport;
            let tempArray = [];
            let option = [];
            for (var item of gametypeArray) {
                if (item.game_key == this.state.selectedGameType) {
                    tempArray = item.allowed_sports || ''
                }
            }
            if (tempArray != '') {
                for (var obj of tempArray) {
                    var sportsId = '';
                    if (obj in Sports.url) {
                        sportsId = Sports.url[obj] + "";
                    }
                    option.push({
                        'label': sportsId,
                        'value': obj
                    })
                }
            }
            this.setState({
                AvaSports: option
            })
        }
    }

    checkSportId = () => {
        let interval = setInterval(() => {
            if (Constants.AppSelectedSport != null) {
                clearInterval(interval)
                this.setState({ activeSportsTab: Constants.AppSelectedSport })
            }
        }, 100)
    }

    /**
     * @description will be called when user tap on filter icon on header
     * @return UI components
    */
    showFilterData = () => {
        this.setState({ showLobbyFitlers: true });
    }
    /**
     * @description will be called when user tap on filter  done icon 
     * @return UI components
    */
    hideFilterData = () => {
        this.setState({
            showLobbyFitlers: false
        });
    }

    onSelect = (tab, fromMount) => {

        if (!fromMount) {
            this.setState({ urlParams: '' })
            if (tab === "lobby")
                this.props.history.push('/' + tab + "#" + Utilities.getSelectedSportsForUrl() + Utilities.getGameTypeHash())
            else if (tab === "my-contests")
                this.props.history.push('/' + tab + "?contest=upcoming")
            else
                this.props.history.push('/' + tab)
        }

        this.setHeaderOptions(tab);
    }

    setHeaderOptions(tab) {

        let { HeaderOption, sportsList, selectedGameType } = mContext.state;
        HeaderOption.title = '';
        HeaderOption.edit = false;
        HeaderOption.filter = false;
        HeaderOption.notification = false;
        HeaderOption.hideHeader = false;
        HeaderOption.close = false;
        if (tab === 'my-contests') {
            HeaderOption.title = Constants.SELECTED_GAMET == Constants.GameType.OpenPred || Constants.SELECTED_GAMET == Constants.GameType.OpenPredLead || Constants.SELECTED_GAMET == Constants.GameType.Pickem ? AppLabels.MY_CONTEST : '';
            HeaderOption.notification = true;
            HeaderOption.hideShadow = true;
            HeaderOption.DFSPrimary = true;
            HeaderOption.filter = Constants.SELECTED_GAMET == Constants.GameType.OpenPred || Constants.SELECTED_GAMET == Constants.GameType.OpenPredLead ? true : false;
        }
        else if (tab === 'my-profile') {
            HeaderOption.edit = true;
            HeaderOption.hideShadow = true;
        }
        else if (tab === 'more') {
            HeaderOption.title = AppLabels.MORE;
            HeaderOption.hideShadow = true;
            HeaderOption.close = true;
        }
        else if (tab === 'lobby') {
            HeaderOption.filter = (Constants.SELECTED_GAMET == Constants.GameType.Pred || Constants.SELECTED_GAMET == Constants.GameType.OpenPred || Constants.SELECTED_GAMET == Constants.GameType.OpenPredLead) ? false : true;
            HeaderOption.isPrimary = (Constants.SELECTED_GAMET == Constants.GameType.Pred || Constants.SELECTED_GAMET == '1' || Constants.SELECTED_GAMET == Constants.GameType.OpenPred || Constants.SELECTED_GAMET == Constants.GameType.OpenPredLead || selectedGameType == Constants.GameType.Pickem || Constants.SELECTED_GAMET == Constants.GameType.Free2Play) ? true : false;
            HeaderOption.notification = true;
            HeaderOption.DFSPrimary = true;
            HeaderOption.hideShadow = sportsList.length > 1 ? true : false;
        }
        else if (tab === 'notification') {
            HeaderOption.title = AppLabels.NOTIFICATIONS;
            HeaderOption.filter = false;
            HeaderOption.notification = false;
            HeaderOption.hideShadow = false;
        }
        else if (tab === 'my-wallet') {
            HeaderOption.title = AppLabels.MY_WALLET;
            HeaderOption.filter = false;
            HeaderOption.notification = false;
            HeaderOption.hideShadow = false;
        }
        else if (tab === 'refer-friend') {
            HeaderOption.title = AppLabels.REFER_A_FRIEND;
            HeaderOption.filter = false;
            HeaderOption.notification = false;
            HeaderOption.hideShadow = false;
        }
        else if (tab === 'earn-coins') {
            HeaderOption.title = AppLabels.HOW_TO_EARN;
            HeaderOption.filter = false;
            HeaderOption.notification = true;
            HeaderOption.hideShadow = true;
        }
        else if (tab === 'leaderboard') {
            HeaderOption.title = Constants.SELECTED_GAMET == Constants.GameType.Free2Play ? AppLabels.F2P_LEAGUES : Constants.SELECTED_GAMET == Constants.GameType.Pickem ? AppLabels.PICKEM + ' ' + AppLabels.LEADERBOARD : AppLabels.LEADERBOARD;
            HeaderOption.filter = Constants.SELECTED_GAMET == Constants.GameType.Free2Play ? false : true;
            HeaderOption.notification = false;
            HeaderOption.hideShadow = true;
            HeaderOption.isPrimary = Constants.SELECTED_GAMET == Constants.GameType.OpenPredLead ? true : Constants.SELECTED_GAMET == Constants.GameType.Pickem ? true : false;
            HeaderOption.FPPLeaderboard = Constants.SELECTED_GAMET == Constants.GameType.OpenPredLead || Constants.SELECTED_GAMET == Constants.GameType.Pickem ? true : false;
            HeaderOption.showLBal = Constants.SELECTED_GAMET == Constants.GameType.OpenPredLead ? true : Constants.SELECTED_GAMET == Constants.GameType.Pickem ? true : false;

        }
        this.checkPickedGame();
        mContext.setState({ HeaderOption, activeTab: tab })
    }

    componentDidUpdate() {
        let tempTab = Constants.DASHBOARD_FOOTER.config.tab_path[window.location.pathname];
        if (this.state.activeTab !== tempTab || this.state.CurrentGameType != Constants.SELECTED_GAMET)
            this.setState({ activeTab: tempTab, CurrentGameType: Constants.SELECTED_GAMET }, () => {
                this.setHeaderOptions(tempTab)
            })
    }
    onTabClick = _debounce((item, index) => {
        if (index === 0) {
            document.querySelector('ul.nav').scrollLeft = 0;
        } else if (index === 3) {
            document.querySelector('ul.nav').scrollLeft = 1000;
        }
        ls.set('selectedSports', item.value);
        Constants.setValue.setAppSelectedSport(item.value);
        this.setState({ activeSportsTab: item.value }, () => {
            if (window.location.pathname === "/lobby") {
                this.props.history.replace(window.location.pathname + "#" + Utilities.getSelectedSportsForUrl() + Utilities.getGameTypeHash())
            }
        });
    }, 200)

    returnLobbyType = () => {
        var LobbyType = Lobby;

        if (Constants.SELECTED_GAMET == Constants.GameType.Pred) {
            LobbyType = PredictionLobby;
        }
        if (Constants.SELECTED_GAMET == Constants.GameType.MultiGame) {
            LobbyType = this.state.MultiGame;
        }
        return LobbyType;
    }
    returnMyContestType = () => {
        var MyContestType = MyContest;

        if (Constants.SELECTED_GAMET == Constants.GameType.Pred) {
            MyContestType = MyPrediction;
        }

        return MyContestType;
    }

    renderTabById(tabItem, activeTab) {
        let LobbyType = this.returnLobbyType();
        let MyContestType = this.returnMyContestType();

        if (tabItem.tab_key === 'lobby') {
            return <Tab key={tabItem.tab_key} eventKey={tabItem.tab_key} title={<div className="animated-tab-div"> <div><i className="icon-home" /></div>
                <div className="tab-label">{AppLabels.HOME}</div>
            </div>}>
                {activeTab === tabItem.tab_key && <LobbyType showLobbyFitlers={this.state.showLobbyFitlers} hideFilterData={this.hideFilterData} {...this.props} selectedSport={this.state.activeSportsTab} />}
            </Tab>
        }
        else if (tabItem.tab_key === 'my-contests') {
            return <Tab key={tabItem.tab_key} eventKey={tabItem.tab_key} title={<div className="animated-tab-div"><div><i className="icon-my-contests" /></div><div className="tab-label">{AppLabels.MY_CONTEST}</div> </div>}>
                {activeTab === tabItem.tab_key && <MyContestType {...this.props} hideHeader={true} urlParams={this.state.urlParams} selectedSport={this.state.activeSportsTab} showLobbyFitlers={this.state.showLobbyFitlers} hideFilter={this.hideFilterData} />}
            </Tab>
        }
        else if (tabItem.tab_key === 'my-profile') {
            return <Tab key={tabItem.tab_key} eventKey={tabItem.tab_key} title={<div className="animated-tab-div"><div><i className="icon-profile" /></div><div className="tab-label">{AppLabels.PROFILE}</div> </div>}>
                {activeTab === tabItem.tab_key && <Profile hideHeader={true} urlParams={this.state.urlParams} {...this.props} selectedSport={this.state.activeSportsTab} />}
            </Tab>
        }
        else if (tabItem.tab_key === 'more') {
            return <Tab key={tabItem.tab_key} eventKey={tabItem.tab_key} title={<div className="animated-tab-div"><div><i className="icon-more-large" /></div><div className="tab-label">{AppLabels.MORE} </div></div>}>
                {activeTab === tabItem.tab_key && <More {...this.props} onLanguageChange={this.setHeaderOptions} />}
            </Tab>
        }
        else if (tabItem.tab_key === 'notification') {
            return <Tab key={tabItem.tab_key} eventKey={tabItem.tab_key} title={<div className="animated-tab-div"><div><i className="icon-alarm-new" /></div><div className="tab-label">{AppLabels.NOTIFICATIONS} </div></div>}>
                {activeTab === tabItem.tab_key && <Notification {...this.props} hideHeader={true} />}
            </Tab>
        }
        else if (tabItem.tab_key === 'my-wallet') {
            return <Tab key={tabItem.tab_key} eventKey={tabItem.tab_key} title={<div className="animated-tab-div"><div><i className="ic icon-wallet-ic" /></div><div className="tab-label">{AppLabels.MY_WALLET}</div> </div>}>
                {activeTab === tabItem.tab_key && <Wallet {...this.props} hideHeader={true} />}
            </Tab>
        }
        else if (tabItem.tab_key === 'refer-friend') {
            return <Tab key={tabItem.tab_key} eventKey={tabItem.tab_key} title={<div className="animated-tab-div"><div><i className="ic icon-add-user" /></div><div className="tab-label">{AppLabels.REFER_A_FRIEND}</div> </div>}>
                {activeTab === tabItem.tab_key && <ReferFriend {...this.props} hideHeader={true} />}
            </Tab>
        }
        else if (tabItem.tab_key === 'earn-coins') {
            return <Tab key={tabItem.tab_key} eventKey={tabItem.tab_key} title={
                <div className="isCoin coin-shine">
                    <div className="shadow-v" />
                    <span className="coins-tab-label">{AppLabels.EARN_COINS}</span>
                    <span className={activeTab === tabItem.tab_key ? "fcoin" : 'position-relative'}>
                        <img src={activeTab === tabItem.tab_key ? Images.EARN_COINS : Images.SILVR_EARN_COINS} alt="" />
                        {
                            activeTab === tabItem.tab_key && <React.Fragment>
                                <div className="spark1">✦</div>
                                <div className="spark2">✦</div>
                                <div className="spark3">✦</div>
                            </React.Fragment>
                        }
                    </span>
                </div>
            } >
                {activeTab === tabItem.tab_key && <this.state.EarnCoins {...this.props} hideHeader={true} showDailyStreak={CustomHeader.showDailyStreak} />}
            </Tab>
        }
        else if (tabItem.tab_key === 'sports-hub') {
            let spImg = Utilities.getMasterData().hub_icon;
            return <Tab key={tabItem.tab_key} eventKey={tabItem.tab_key} title={
                <div className="isCoin coin-shine">
                    <div className="shadow-v logo-hub" />
                    {!spImg && <span className="coins-tab-label">{AppLabels.SPORTS_HUB}</span>}
                    <span className={"position-relative" + (spImg ? " upload-img" : "")}>
                        <img src={spImg ? Utilities.getSettingURL(spImg) : Images.SPORTS_HUB} alt="" />
                    </span>
                </div>
            } />
        }
    }

    renderHelmetData = (ATab) => {
        let isLobby = ATab === 'lobby';
        let isMyContast = ATab === 'my-contests';
        let isCoins = ATab === 'earn-coins';
        let isProfile = ATab === 'my-profile';
        let isLeaderboard = ATab === 'leaderboard';
        let isMore = ATab === 'more';
        var data = '';

        if (isLobby) {
            data = MetaData.lobby;
        } else if (isMyContast) {
            data = MetaData.contests;
        } else if (isCoins) {
            data = MetaData.ERNC;
        } else if (isProfile) {
            data = MetaData.myprofile;
        } else if (isMore) {
            data = MetaData.more;
        } else if (isLeaderboard) {
            data = MetaData.leaderboard;
        }


        return (
            <Helmet titleTemplate={`${MetaData.template} | %s`}>
                <title>{data.title}</title>
                <meta name="description" content={data.description} />
                <meta name="keywords" content={data.keywords}></meta>
            </Helmet>
        )
    }
    scroll = (scrollOffset) => {        
        this.ref.current.scrollLeft+= scrollOffset;
    };

    renderTopSportsTab = () => {
        let { AvaSports, activeSportsTab, sportsList } = this.state;
        return (
            <Tab.Container id='top-sports-slider' onSelect={() => console.log('onSelect')} activeKey={activeSportsTab.toString()} defaultActiveKey={activeSportsTab.toString()} className={Constants.SELECTED_GAMET == Constants.GameType.OpenPred ? 'hide' : ''}>
                <Row className="clearfix">
                    <Col className="sports-tab-nav custom-scrollbar " xs={12}>
                        <Nav >
                            <div ref={this.ref} style={{overflowX:"scroll"}}>
                            {
                                _Map(AvaSports, (item, idx) => {
                                    return (
                                        <NavItem key={item.value} style={{ width: 'calc(100% / ' + AvaSports.length + ')' }} onClick={() => this.onTabClick(item, idx)} eventKey={item.value.toString()}>
                                            <span>
                                                {item.value == 6 ? <img src={hockeyIcon} alt="" srcset="" style={{ height: "20px", paddingRight: "5px", paddingBottom: "2px" }} /> : <i className={"icon-" + item.value + "-ic"} />}
                                                {
                                                    Sports.url[item.value + (WSManager.getAppLang() || '')]
                                                }
                                            </span>
                                        </NavItem>

                                    )
                                })
                            }
                            </div>
                        </Nav>
                        <div style={{
                            right: "0px",
                            position: "absolute",
                            right: 0,
                            top: 0,
                            padding: "10px 6px",
                            background: "rgb(2,0,36)",
                            background: "linear-gradient(90deg, rgba(2,0,36,0.5116640406162465) 98%, rgba(40,0,255,0.1503195028011205) 100%)"

                        }}
                        onClick={()=>this.scroll(120)}
                        >
                            <img src="/arrow-forward.png" alt="" height={20} style={{ postion: "absolute", right: 0 }} />
                        </div>
                    </Col>
                </Row>
            </Tab.Container>
        )
    }

    checkPickedGame = () => {
        let returnValue = false;
        if (!Constants.SELECTED_GAMET && Constants.IS_SPORTS_HUB) {
            returnValue = true;
            this.props.history.push("/sports-hub#" + Utilities.getSelectedSportsForUrl())
        }
        return returnValue;
    }

    render() {
        let { sportsList, activeTab, getGameTypeSport, AvaSports } = this.state;
        mContext = this;

        let isLobby = activeTab === 'lobby';
        let isMyContast = activeTab === 'my-contests';
        let isCoins = activeTab === 'earn-coins';
        let isProfile = activeTab === 'my-profile';
        let isMore = activeTab === 'more';
        let isLeaderboard = activeTab === 'leaderboard';

        var showLobbySportsTab = process.env.REACT_APP_LOBBY_SPORTS_ENABLE == 1 ? true : (Constants.IS_SPORTS_HUB ? false : true)

        return (

            <MyContext.Provider value={this}>
                <div className={"web-container transparent-header lobby-web-container web-container-fixed " + (sportsList.length > 1 ? ' ' : 'web-container-no-fixed') + (isProfile ? 'white-bg profile-web-container' : '') + (isMore ? ' more-web-container' : '') + (isLeaderboard ? ' header-with-img' : '')}>

                    {this.renderHelmetData(activeTab)}

                    {!isProfile &&
                        <CustomHeader {...this.props} HeaderOption={this.state.HeaderOption} showLobbyFitlers={this.showFilterData} getGameTypeSport={getGameTypeSport} />
                    }


                    <div className={
                        "dashboard-container" + (isProfile ? ' without-header ' : (
                            isMore || isCoins || sportsList.length < 2 ||
                            (!showLobbySportsTab || AvaSports.length == 0 || AvaSports.length == 1) || (Constants.SELECTED_GAMET == Constants.GameType.OpenPred)
                            // (!showLobbySportsTab || Constants.SELECTED_GAMET != Constants.GameType.DFS)
                        ) ? ' without-sports-tab' : '') + ((Constants.SELECTED_GAMET == Constants.GameType.Pickem && isLeaderboard) ? ' without-sports-tab' : '') + (isMyContast ? ' dashboard-my-contest' : '') + (showLobbySportsTab && this.state.HeaderOption.isPrimary ? ' sports-tab-primary' : '')}>
                        {
                            (
                                // (sportsList.length > 1 && 
                                (AvaSports.length > 1 &&
                                    (isLobby || isMyContast)) &&
                                (showLobbySportsTab)
                                // (showLobbySportsTab && Constants.SELECTED_GAMET == Constants.GameType.DFS)
                            ) &&
                            this.renderTopSportsTab()
                        }
                        <Tabs id='bottom-tabs' animation={false} onSelect={(tab) => this.onSelect(tab, false)} activeKey={this.state.activeTab} defaultActiveKey={'lobby'} className="dasboard-footer-tabs">
                            {this.state.footerTabs !== undefined &&
                                _Map(this.state.footerTabs, (item, idx) => {
                                    return (
                                        this.renderTabById(item, activeTab)
                                    )
                                })
                            }
                        </Tabs>
                    </div>
                </div>
            </MyContext.Provider>
        )
    }
}
